// TODO...

const note_story_from_hashtag_subscription = {
  key: "note_story_from_hashtag_subscription",
  label_data: "new story from hashtag subscription",
  label_detail: "A story is published with a hashtag I'm subscribed to.",
  // label_note: ({ user }) => `A new ${hashtag} story has been published.`,
  // link: ({ slug }) => `/story/${slug}`,
};

module.exports = note_story_from_hashtag_subscription;
